import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

const uploadStorage = async (file) => {
  const formData = new FormData()

  formData.append('file', file, file.name)

  const response = await apiClientV2({
    baseURL,
    method: 'PUT',
    url: '/storage/upload',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })

  return response?.data
}

export default uploadStorage
